import { render, staticRenderFns } from "./ArrowPageLeftIcon.vue?vue&type=template&id=f7d39c74"
import script from "./ArrowPageLeftIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowPageLeftIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports